import { css, styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);
